module.exports = __webpack_public_path__ + "media/images/logo-black-studio-cd24bc71.png";